module.exports = __webpack_public_path__ + "static/media/pig2019_2-tc.628730af.jpg";